// app/javascript/controllers/message_form_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "submitButton"];

  submitOnEnter(event) {
    if (event.key !== "Enter") return;

    event.preventDefault();

    // Only trigger a click if the submit button exists and is not disabled.
    if (this.submitButtonTarget && !this.submitButtonTarget.disabled) {
      this.submitButtonTarget.click();

      // Clear the content field only if it is valid, and disable the button.
      if (this.contentTarget.validity.valid) {
        this.contentTarget.value = "Sending...";
        this.contentTarget.disabled = true;
        this.submitButtonTarget.disabled = true;
        this.submitButtonTarget.value = "...";
      }
    }
  }
}
